import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { FormModal } from "../components/FormModal";
import { formConfigs } from "../utils/formsConfig";
import { _api } from "../auth/Api";
import { Toast } from "../components/SweatAlert";

const MasterLayout = ({ children }) => {
  const { loggedInUser, loginUser, logoutUser } = useUser();
  //console.log(loggedInUser)
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  let [passwordModal, setPasswordModal] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const navigate = useNavigate();
  useEffect(() => {
    const closeAllDropdowns = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });
    };

    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");
      if (!clickedDropdown) return;
      const isActive = clickedDropdown.classList.contains("open");
      closeAllDropdowns();
      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    // Close all dropdowns on route change
    closeAllDropdowns();

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const handleLogout = () => {
    logoutUser();
    // localStorage.removeItem("isAuthenticated")
    navigate('/sign-in')
  }
  // const handleLogout = () => {
  //   dispatch(logout());
  // };
  const launchModal = (d, type) => {
    setPasswordModal(type)
  }
  const _changePassword = async (d) => {
    const payload = { ...d, userEmail: loggedInUser && loggedInUser.user?.userEmail }
    try {
      await _api("POST", "PortalUser/ChangePassword", payload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: 'success', title: res.message });
          setPasswordModal(false)
        } else {
          Toast.fire({ icon: 'error', title: res.message });
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo'>
            <img
              src='assets/images/changan-logo/logo-with-text.png'
              alt='site logo'
              className='light-logo w-75'
            />
            <img
              src='assets/images/changan-logo/logo-with-text-light.png'
              alt='site logo'
              className='dark-logo w-75'
            />
            <img
              src='assets/images/changan-logo/logo-icon.png'
              alt='site logo'
              className='logo-icon w-90'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className="sidebar-menu" id="sidebar-menu">
            {loggedInUser &&
              loggedInUser.roles[0].pages.map((menu, index) => (
                <React.Fragment key={index}>
                  <li className={menu.submenus ? "dropdown" : ""}>

                    <NavLink
                      to={menu.url}
                      className={(navData) => (navData.isActive ? "active-page" : "")}
                    >
                      <Icon icon={menu.icon} className="menu-icon" />
                      <span>{menu.pageName}</span>
                    </NavLink>

                  </li>
                </React.Fragment>
              ))}
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                    icon='fe:text-align-left'
                      className='icon text-2xl non-active text-secondary-light'
                    />
                  ) : (
                    <Icon
                      icon='fe:text-align-right'
                      className='icon text-2xl non-active text-secondary-light'
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                <div className='dropdown'>
                  <button
                     className='has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <img
                      style={{maxWidth:"80%"}}
                      src='assets/images/changan-logo/logo-icon.png'
                      alt='image_user'
                      className='object-fit-cover rounded-circle'
                    />
                    {/* <Icon
                      icon='mdi:account'
                      className='text-primary-light text-xl'
                    /> */}
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          {loggedInUser && loggedInUser.user?.firstName + " " + loggedInUser.user?.lastName}
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                          {loggedInUser && loggedInUser.roles[0]?.roleName || "--User"}
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-lg'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      <li onClick={() => launchModal({}, true)}>
                        <Link className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <Icon icon='solar:lock-linear' className='icon text-lg' /> Change Password
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3' to='/view-profile'>
                          <Icon icon='solar:user-linear' className='icon text-xl' /> My Profile
                        </Link>
                      </li>
                      <li onClick={handleLogout}>
                        <Link className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'>
                          <Icon icon='solar:login-2-linear' className='icon text-xl' /> Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FormModal
          page="New Password"
          size="md"
          config={formConfigs.setup_changePassword}
          // selectedData={data} // selected row
          show={passwordModal}
          modalshow={(d, type) => launchModal(d, type)}
          modalsave={(d) => _changePassword(d)}
        />

        <div className='dashboard-main-body'>{children}</div>

        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0 text-sm'>© Changan 2025. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <p className='mb-0 text-sm'>
                Made by <a href="https://dtspk.com/" target="_blank" className="text-primary-500">Dynamics Technology Systems</a>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
